/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WbsTestataDTO } from './WbsTestataDTO';
import {
    WbsTestataDTOFromJSON,
    WbsTestataDTOFromJSONTyped,
    WbsTestataDTOToJSON,
    WbsTestataDTOToJSONTyped,
} from './WbsTestataDTO';

/**
 * 
 * @export
 * @interface WbsDTO
 */
export interface WbsDTO {
    /**
     * 
     * @type {WbsTestataDTO}
     * @memberof WbsDTO
     */
    wbs?: WbsTestataDTO;
}

/**
 * Check if a given object implements the WbsDTO interface.
 */
export function instanceOfWbsDTO(value: object): value is WbsDTO {
    return true;
}

export function WbsDTOFromJSON(json: any): WbsDTO {
    return WbsDTOFromJSONTyped(json, false);
}

export function WbsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WbsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'wbs': json['wbs'] == null ? undefined : WbsTestataDTOFromJSON(json['wbs']),
    };
}

export function WbsDTOToJSON(json: any): WbsDTO {
    return WbsDTOToJSONTyped(json, false);
}

export function WbsDTOToJSONTyped(value?: WbsDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wbs': WbsTestataDTOToJSON(value['wbs']),
    };
}

